/// <amd-module name="typeahead/features/ShowRecentHistorySuggestion" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/IPageLoadHandler.d.ts" />

import {EmptyQueryDataProvider} from "typeahead/core/EmptyQueryDataProvider";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, SuggestionCategory} from "typeahead/core/Suggestion";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";

const configuration: IStripingConfiguration[] = [
    {
        tabs: ["hotel"],
    },
    {
        clients: ["Hotels.Search"],
    },
    {
        clients: ["Homepage"],
        experiment: {
            id: 14180,
            name: "RecentHistoryLX",
            value: 1,
        },
        tabs: ["activity"],
    },
    {
        clients: ["LXLandingPage"],
        experiment: {
            id: 14180,
            name: "RecentHistoryLX",
            value: 1,
        },
    },
];

const excludedPages = [
    {
        clientId: "Homepage",
        locale: "ja_JP",
        siteid: "28",
    },
    {
        clientId: "HotelsLandingPage",
        locale: "ja_JP",
        siteid: "28",
    },
];

export class ShowRecentHistorySuggestion implements IPageLoadHandler, IFocusSuggester, IExperimentalFeature {

    private results: IEssSuggestionResult[];

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {
        let opts = $.extend(true, {}, {options, context});
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        new EmptyQueryDataProvider().fetchData(opts).then((response: IDataProviderResponse) => {
            this.results = this.filterRecentHistoryResults(<IEssSuggestionResult[]> response.results);
            deferred.resolve();
        });
        return deferred.promise();
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        let deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                if (shouldExecute && !this.isExcluded(context)) {
                    deferred.resolve({id: this.getId(), results: this.results});
                }
            })
            .always(() => {
                deferred.resolve({id: this.getId(), results: []});
            });
        return deferred.promise();
    }

    public suggestOnFocus(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        return this.suggest(options, context);
    }

    public getId(): SuggesterId {
        return SuggesterId.RecentHistorySuggester;
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private isExcluded(context): boolean {
        for (let page of excludedPages) {
            if (page.clientId === context.clientId
                && page.locale === context.locale
                && page.siteid === context.siteid + "") {
                return true;
            }
        }
        return false;
    }

    private filterRecentHistoryResults(results: IEssSuggestionResult[]): IEssSuggestionResult[] {
        let recentHistoryFilter = (result: IEssSuggestionResult) => {
            return result.category === SuggestionCategory[SuggestionCategory.USERHISTORY];
        };
        if (results && results.length) {
            return results.filter(recentHistoryFilter);
        } else {
            return [];
        }
    }
}
